import { render, staticRenderFns } from "./other_incident.vue?vue&type=template&id=705f97b6"
import script from "./other_incident.vue?vue&type=script&lang=js"
export * from "./other_incident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports